export default "__VITE_ASSET__DqYo2mNA__"